import { render, staticRenderFns } from "./ProPanel.vue?vue&type=template&id=277ecf62&"
import script from "./ProPanel.vue?vue&type=script&lang=js&"
export * from "./ProPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports